<div class="content">
  <div class="cards">
    <div class="header">
      <div class="header__column">
        <h1 class="title">
          {{'enterpriseCardsTitle'|translate}}
        </h1>
        <span class="description">
          {{'enterpriseCardsDescription'|translate}}
        </span>
      </div>
      <p-button [label]="'addCard'|translate" (click)="this.selectedCard = null!; hideFormNewCard(); visibleForm = true"/>
    </div>

    <p-table [value]="cards()" [tableStyle]="{ 'min-width': '50rem' }">
      <ng-template #header>
        <tr>
          <th>
            {{'companyName'|translate}}
          </th>
          <th>
            {{'companyCardNumber'|translate}}
          </th>
          <th style="width: 5rem">
            {{'actions'|translate}}
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-product>
        <tr>
          <td>{{ product.Name }}</td>
          <td>{{ product.Number }}</td>
          <td>
            <p-button
              (click)="menu.toggle($event); selectedCard = product"
              icon="pi pi-ellipsis-h"
              severity="secondary"
              rounded
            />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="settings">
    <div class="header">
      <div class="header__column">
        <h1 class="title">
          {{'downloadSettings'|translate}}
        </h1>
        <span class="description">
          {{'enterpriseCardsDefaultDownloadSettingsDescription'|translate}}
        </span>
      </div>
    </div>

    <form [formGroup]="formCard">
      <div class="settings__form">
        <div class="settings__form__column">
          <span class="label" [innerHTML]="'enterpriseCardsDownloadTachographEvery'|translate"></span>
          <div class="input">
            <input formControlName="TachographMemoryReadDaysInterval" type="number" />
            <span class="input__placeholder">
              {{'days'|translate}}
            </span>
          </div>
          <div
            [pTooltip]="tooltipContent"
            tooltipStyleClass="tooltip--tacho-config"
            tooltipPosition="right"
            class="tip"
          >
            <i class="pi pi-question"></i>
          </div>
        </div>

        <div class="settings__form__column">
          <span class="label" [innerHTML]="'enterpriseCardsDownloadDriverCardEvery'|translate"></span>
          <div class="input">
            <input formControlName="DriverCardReadDaysInterval" type="number" />
            <span class="input__placeholder">
              {{'days'|translate}}
            </span>
          </div>
          <div
            [pTooltip]="tooltipContentDriverCard"
            tooltipStyleClass="tooltip--tacho-config"
            tooltipPosition="right"
            class="tip"
          >
            <i class="pi pi-question"></i>
          </div>
        </div>
      </div>
    </form>

    <p-button (click)="saveSettings()" [label]="'saveChanges'|translate" [loading]="isSaveingSettings()" [style]="{ 'width': '160px' }"/>
  </div>
</div>

<p-menu
  #menu
  [model]="cardsListAction"
  [popup]="true"
  styleClass="menu-positioned-left"
/>

<ng-template #tooltipContent>
  <div class="tooltip-info">
    <span>
      {{ 'enterpriseCardsTachographLegalNote' | translate }}
    </span>
  </div>
</ng-template>

<ng-template #tooltipContentDriverCard>
  <div class="tooltip-info">
    <span>
      {{ 'driverDataTachographNote' | translate }}
    </span>
  </div>
</ng-template>

<p-dialog [header]="'enterpriseCardsNewCompanyCard'|translate" [modal]="true" [(visible)]="visibleForm" [style]="{ width: '720px' }">
  <form [formGroup]="addCompanyCardForm" class="form-add-card">
    <div class="flex flex-col gap-2" style="max-width: 300px;">
      <label for="company-name">
        {{'companyName'|translate}}
      </label>
      <input formControlName="Name" pInputText id="company-name"/>
    </div>
    <div class="flex flex-col gap-2" style="max-width: 300px;">
      <label for="company-card">
        {{'companyCardNumber'|translate}}
      </label>
      <input formControlName="Number" pInputText id="company-card"/>
    </div>

    <div class="flex justify-end gap-2 mt-3">
      <p-button [label]="'labels.cancel'|translate" severity="secondary" (click)="hideFormNewCard()" />
      <p-button (click)="saveFormCompanyCard()" [label]="'labels.save'|translate" [style]="{ width: '100px' }"/>
    </div>
  </form>
</p-dialog>
